import type { CombinedError } from "urql"
import { useMutation } from "urql"

import type { ContactLocationDeleteOutput, ContactMutationDeleteContactLocationArgs } from "@/graphql/codegen/graphql"
import { DeleteContactLocationMutationDocument } from "@/graphql/codegen/graphql"

export const useRemoveContactLocation = (): {
  removeResult: boolean
  removeContactLocation: (
    input: ContactMutationDeleteContactLocationArgs
  ) => Promise<ContactLocationDeleteOutput | undefined>
  isRemovingError: CombinedError | undefined
} => {
  const [mutation, executeMutation] = useMutation<
    ContactLocationDeleteOutput,
    ContactMutationDeleteContactLocationArgs
  >(DeleteContactLocationMutationDocument)

  const removeContactLocation = async (input: ContactMutationDeleteContactLocationArgs) => {
    const result = await executeMutation(input)

    if (result.error) {
      throw new Error(result.error.message)
    }

    const removeResult = result.data?.contact.deleteContactLocation.isSuccessful
    if (!removeResult) {
      throw new Error(removeResult.error.message)
    }

    return removeResult
  }

  return {
    removeResult: mutation.data?.contact.deleteContactLocation.isSuccessful ?? false,
    removeContactLocation,
    isRemovingError: mutation.error,
  }
}
